import React from 'react'
import styled from 'styled-components'
import { Dialog } from '@progress/kendo-react-dialogs'
import { Input } from '@progress/kendo-react-inputs'
import { Button } from '@progress/kendo-react-buttons'
import { Form, Field } from '@progress/kendo-react-form'
import { SafeCheckbox } from '../styled/FormComponents'

export default function EditDialog (props) {

    const handleSubmit = (event) => {
        props.save(event)
    }

    const renderDialogContentFields = () => {
        const content = props.dialogContentFields
        return content.map((field) => {
            return(
                <div key={field.description}>
                    {field.description !== 'Admin'
                        ? (
                            <span>
                                <FieldDescription>{field.description}</FieldDescription>
                                <StyledField name={field.name} component={Input} />
                            </span>
                        )
                        : (
                            <Field name={field.name} label={field.description} component={SafeCheckbox}/>
                        )
                    }
                </div>
            )
        })
    }

    return (
        <Dialog
            onClose={props.cancel}
        >
            <Form initialValues={props.dataItem} onSubmit={handleSubmit} render={(formRenderProps) => (
                <div>
                    {renderDialogContentFields()}

                    <ButtonSection style={{ marginTop: '15px' }}>
                        <StyledButton onClick={props.cancel}>Abbrechen</StyledButton>
                        <StyledButton primary disabled={!formRenderProps.modified} onClick={() => formRenderProps.onSubmit()}>Speichern</StyledButton>
                    </ButtonSection>
                </div>
            )}/>
        </Dialog>
    )
}

const ButtonSection = styled.div`
    display: flex;
    justify-content: flex-end;
`

const StyledButton = styled(Button)`
    margin-left: 10px;
`

const FieldDescription = styled.p`
    margin: inherit; 
    font-weight: bold; 
    font-size: 13px
`

const StyledField = styled(Field)`
    margin-bottom: 15px; 
    width: 300px;
`



// WEBPACK FOOTER //
// ./src/components/dialog/BaseDataDialog.js